import { alpha3ToAlpha2 } from "@utils/countryCodeMap";

const isAlpha2 = (value) => /^[A-Za-z]{2}$/.test(value);
const isAlpha3 = (value) => /^[A-Za-z]{3}$/.test(value);

const resolveAlpha2Code = (countryOrCode) => {
  if (!countryOrCode) return null;

  if (typeof countryOrCode === "string") {
    const normalized = countryOrCode.trim();
    if (!normalized) return null;

    if (isAlpha2(normalized)) {
      return normalized.toLowerCase();
    }

    if (isAlpha3(normalized)) {
      return alpha3ToAlpha2[normalized.toUpperCase()] || null;
    }

    return null;
  }

  const fromObject =
    countryOrCode.code_alpha2 ||
    countryOrCode.alpha2 ||
    countryOrCode.iso2 ||
    countryOrCode.code2 ||
    countryOrCode.code;

  return resolveAlpha2Code(fromObject);
};

export const getFlagUrl = (countryOrCode) => {
  const code2 = resolveAlpha2Code(countryOrCode);
  if (!code2) return null;

  return `https://flagcdn.com/w20/${code2}.png`;
};
